import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/bff-prompts';
import { map } from 'rxjs/operators';

export interface Categoria {
  categoria_id?: number; // Gerado pelo backend
  categoria_descricao: string;
  categoria_pai?: string;
  status: string;
}

@Injectable({
  providedIn: 'root',
})
export class CategoriaService {
  constructor(private apiService: ApiService) {}

  listarCategorias(): Observable<Categoria[]> {
    return this.apiService
      .get<{ message: string; data: Categoria[] }>('/categoria/')
      .pipe(map((response) => response.data));
  }

  buscarCategoriaPorId(id: number): Observable<Categoria[]> {
    return this.apiService
    .get<{ message: string; data: Categoria[] }>(`/categoria/`)
    .pipe(map((response) => response.data));
  }

  criarCategoria(categoria: Categoria): Observable<Categoria> {
    return this.apiService.post<Categoria>('/categoria/', categoria);
  }

  editarCategoria(id: number, categoria: Categoria): Observable<Categoria> {
    return this.apiService.put<Categoria>(`/categoria/${id}`, categoria);
  }

  excluirCategoria(id: number): Observable<void> {
    return this.apiService.delete<void>('categoria', id);
  }
}
